// @ts-nocheck
(() => {
	const FormState = {
		INITIAL: 0,
		SUBMITTED: 1,
	};

	const emailRegex = new RegExp(
		/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
	);

	/**
	 * Custom stockbot submit. API is undocumented to may need
	 * updating if they change anything!
	 *
	 * @param {number} product_id
	 * @param {number} variant_id
	 * @param {string} email
	 * @returns {Promise<boolean>}
	 * @throws {Error}
	 */
	async function _stockbotSubmit(product_id, variant_id, email) {
		const url = 'https://stockbot.oostapps.com/api/public/v1/watches';
		const headers = {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			'X-Shopify-Domain': window.Shopify.shop,
		};
		const body = { product_id, variant_id, email };
		const response = await fetch(url, {
			method: 'post',
			headers: headers,
			body: JSON.stringify(body),
		});
		if (response.ok) {
			// Returns a string if successful, or an object if not (I know, right?)
			const responseJson = await response.json();
			if (responseJson === 'Done') {
				return true;
			} else if (responseJson.message) {
				throw new Error(responseJson.message);
			}
			return false;
		} else {
			const body = await response.text();
			throw new Error(body);
		}
	}

	document.addEventListener('alpine:init', function () {
		Alpine.data('productOOS', ({ product_title, product_id, variant_id, is_open }) => ({
			state: FormState.INITIAL,
			email: '',
			product_title: product_title,
			variant_title: '',
			product_id: product_id,
			variant_id: variant_id,
			hasError: false,
			isLoading: false,
			get hasSubmitted() {
				return this.state === FormState.SUBMITTED;
			},
			get canSubmit() {
				return (
					!this.isLoading &&
					this.product_id &&
					this.variant_id &&
					emailRegex.test(this.email)
				);
			},
      get stateClasses() {
        const c = [];
        if(this.isLoading) {
          c.push(' is-loading');
        }
        if(this.hasError) {
          c.push(' has-error');
        }
        return c.join('');
      },
			reset(fullReset = true) {
				this.variant = null;
				this.variant_id = 0;
				this.hasError = false;
				if (fullReset) {
					this.email = '';
					this.state = FormState.INITIAL;
					this.isLoading = false;
				}
			},
			async onSubmit() {
				if (this.canSubmit) {
					try {
						this.isLoading = true;
						this.hasError = false;
						await _stockbotSubmit(this.product_id, this.variant_id, this.email);
						this.state = FormState.SUBMITTED;
					} catch (error) {
						console.error(error);
						this.hasError = true;
					} finally {
						this.isLoading = false;
					}
				}
			},
			init() {
				// Reset state on modal close
				const oosModal = document.getElementById('modal_product_oos');
				if (oosModal) {
					oosModal.addEventListener('close', this.reset.bind(this));
				}
        
        // Open on OOS variant select
				window.addEventListener(
					'shop::product:variant:selected',
					/** @param {CustomEvent} event */
					event => {
						// Reset state on variant selected
						this.reset(false);
						const variant = event.detail.variant;
            const product_id = event.detail.product_id;
						// Open modal if variant out of stock and modal exists
						if (variant) {
              if(product_id) {
                this.product_id = product_id;
              }
							this.variant_title = variant.title;
							this.variant_id = variant.id;
							if (!variant.available && oosModal) {
								oosModal.open();
							}
						}
					}
				);
        
        // Maybe open modal on init 
        if(is_open && oosModal) {
          oosModal.open();
        }
			},
		}));
	});
})();
